<template>
  <div class="fan-curve" :style="{'width':`${curvesWidth}px`}">
    <curve-points-filter 
      v-if="designPropertyData && operatingData"
      :design-property-data="designPropertyData"
      :air-volume="performanceCurveData.powerConsumptionPerAirVolume"
      :operating-data="operatingData"
      @on-design-checked="designChange"
      @on-operating-checked="operatingChange" />
    <div class="performance-curve-container">
      <div v-if="showSpeed" class="select-section">
        <span>转速</span>
        <el-select v-model="speed" class="selector" size="small" @change="speedChange">
          <el-option 
            v-for="(o,i) in speedOptions" 
            :key="i" 
            :label="o.label"
            :value="o.value"
          />
        </el-select>
       </div>
      <div class="curve-selection-no-speed" :class="{'curve-selection':showSpeed}">
        <span>曲线</span>
      </div>
      <div ref="curveChart" class="performance-curve" :style="{'width':`${curvesWidth}px`,'height':`${curvesHeight}px`}" />
    </div>
  </div>
</template>
<script>
import echarts from '@/plugins/echarts'
import CurvePointsFilter from './CurvePointsFilter.vue'
export default {
  name: 'FanCurve',
  components: {
    CurvePointsFilter
  },
  props: {
    performanceCurveData: {
      type: Object,
      required: true
    },
    curvesWidth: {
      type: Number,
      default: 752
    },
    curvesHeight: {
      type: Number,
      default: 576
    },
    colors: {
      type: Object,
      default() {
        return {
          curveColors: ['#3A79F3', '#9214BE', '#D9236F', '#FC871B', '#98C90D', '#16B9A5'],
          deepCurveColors: {
            全压: '#3A79F3',
            全压效率: '#9214BE',
            静压: '#D9236F',
            静压效率: '#FC871B',
            轴功率: '#98C90D',
            噪声: '#16B9A5', 
          },
          parabolaColor: '#8892A0',
        }
      }
    },
  },
  data() {
    // const that = this
    return {
      speed: 'all',
      // option初始设置
      option: {
        animation: false,
        axisPointer: {
          link: { xAxisIndex: 'all' }
        },
        tooltip: {
          trigger: 'none',
          axisPointer: {
            type: 'cross'
          },
        },
      },
      myChart: null,
      showDesignPoints: true,
      showOperatingPoints: true
    }
  },
  computed: {
    parabolas() {
      return this.performanceCurveData.parabolas
    },
    designPropertyData() {
      return this.performanceCurveData.designPropertyData
    },
    operatingData() {
      return this.performanceCurveData.operatingData
    },
    showSpeed() {
      return this.performanceCurveData.speeds && this.performanceCurveData.speeds.length > 1
    },
    speedOptions() {
      const speeds = this.performanceCurveData.speeds
      if (speeds && speeds.length) {
        const options = [
          {
            value: 'all',
            label: '全部'
          }
        ]
        speeds.forEach((s) => {
          options.push({
            value: s,
            label: s
          })
        })
        return options
      }
      return []
    },
  },
  methods: {
    init() {
    // myChart初始化一次即可
      if (!this.myChart) {
        this.generateCurves()
      }
    },
    showCurve(refresh = false) {
      const curveChart = this.$refs.curveChart
      if (curveChart) {
        if (!this.myChart) {
          this.myChart = echarts.init(curveChart)
        }
        this.myChart.setOption(this.option, refresh)
        console.log('this.option', this.option)
      }
    },
    getYAxis(name) {
      const yAxises = this.performanceCurveData.yAxises
      const axis = yAxises.find((a) => a.name === name)
      return axis || {}
    },
    getDefaultSeriesOption(curve) {
      return {
        name: curve.yName,
        type: 'line',
        smooth: true,
        showSymbol: false,
        endLabel: {
          show: this.showSpeed,
          align: 'center',
          formatter: curve.speed,
          color: 'inherit',
          offset: [10, 10]
        },
        data: curve.data
      }
    },
    getParabolaSeries() {
      const series = []
      const parabolas = this.parabolas
      if (parabolas.length) {
        parabolas.forEach((p, index) => {
          const singleSeries = { 
            name: `parabola${index}`,
            smooth: true,
            xAxisIndex: 0,
            yAxisIndex: 0,
            type: 'line',
            showSymbol: false,
            data: p.data,
            color: this.colors.parabolaColor,
            markPoint: {
              symbol: 'circle',
              data: [
                {
                  coord: p.designPoint && (p.designPoint[1] || p.designPoint[1] === 0) ? p.designPoint : null,
                  symbolSize: 10,
                  itemStyle: {
                    color: this.colors.parabolaColor,
                  }
                }
              ]
            }
          }
          series.push(singleSeries)
        })
      }
      return series
    },
    getCurveMarkPoint(operatingPoint) {
      let markPoint = null
      if (this.showOperatingPoints && this.operatingData && operatingPoint) {
        markPoint = {
          symbol: 'circle',
          data: [
            {
              coord: operatingPoint,
              symbolSize: 10,
            }
          ]
        }
      }
      return markPoint
    },
    generateCurves() {
      const { xAxises, yAxises, curves } = this.performanceCurveData
      const xAxis = xAxises[0]
      const yLength = yAxises.length
      const option = this.option
      if (yLength) {
        if (yLength <= 3) {
          option.grid = [{ right: yLength <= 2 ? 75 : 150 }]
          option.xAxis = [
            {
              type: 'value',
              gridIndex: 0,
              min: xAxis.min,
              max: xAxis.max,
              interval: xAxis.interval,
              name: `${xAxis.name}(${xAxis.unit})`,
              nameLocation: 'middle',
              nameTextStyle: {
                padding: 16
              },
              axisLine: {
                lineStyle: {
                  color: '#14141E'
                }
              },
              axisLabel: {
                showMinLabel: true
              },
            }
          ]
        } else {
          option.grid = [
            { bottom: '52%', right: 150 },
            { top: '52%', right: 150 }
          ]
          option.xAxis = [
            {
              type: 'value',
              gridIndex: 0,
              min: xAxis.min,
              max: xAxis.max,
              interval: xAxis.interval,
              axisLabel: {
                show: false,
              },
              axisLine: {
                lineStyle: {
                  color: '#14141E'
                }
              },
            },
            {
              type: 'value',
              gridIndex: 1,
              min: xAxis.min,
              max: xAxis.max,
              interval: xAxis.interval,
              name: `${xAxis.name}(${xAxis.unit})`,
              nameLocation: 'middle',
              nameTextStyle: {
                padding: 16,
              },
              axisLine: {
                lineStyle: {
                  color: '#14141E'
                }
              },
              axisLabel: {
                showMinLabel: true
              },
            
            }
          ]
        }
        const yAxisesRes = []
        const legendData = []
        for (let i = 0; i < yLength; i++) {
          const y = yAxises[i]
          let gridIndex = 0
          let position = 'left'
          let offset = 0
          if (i === 0) {
            position = 'left'
          } else if (i === 1) {
            position = 'right'
          } else if (i === 2) {
            if (yLength % 3) {
              position = 'left'
              gridIndex = 1
            } else {
              position = 'right'
              offset = 80
            }
          } else {
            gridIndex = 1
            if (i === 3) {
              if (yLength % 3) {
                position = 'right'
              } else {
                position = 'left'
              }
            } else if (i === 4) {
              position = 'right'
              if (yLength % 3) {
                offset = 80
              } 
            } else if (i === 5) {
              position = 'right'
              offset = 80
            }
          }
          yAxisesRes.push({
            type: 'value',
            name: `${y.name}(${y.unit})`,
            gridIndex, 
            position, 
            offset, 
            min: y.min,
            max: y.max,
            interval: y.interval,
            axisLine: {
              show: true,
              lineStyle: {
                color: this.colors.deepCurveColors[y.name]
              }
            },
            axisLabel: {
              formatter: (value) => {
                return Math.round(value)
              } 
            },
            nameLocation: 'middle',
            nameTextStyle: {
              padding: 22
            },
          })
          legendData.push({ name: y.name })
        }
        option.yAxis = yAxisesRes
        option.legend = {
          data: legendData,
          top: 6,
          left: 54,
          height: 24,
        }
        const series = []
        for (let j = 0; j < curves.length; j++) {
          const curve = curves[j]
          const yAxisIndex = yAxisesRes.findIndex((y) => y.name === `${curve.yName}(${curve.yUnit})`)
          if (yAxisIndex >= 0) {
            const xAxisIndex = yAxisesRes[yAxisIndex] && yAxisesRes[yAxisIndex].gridIndex
            const color = yAxisesRes[yAxisIndex] && yAxisesRes[yAxisIndex].axisLine.lineStyle.color
            const defaultOption = this.getDefaultSeriesOption(curve)
            const markPoint = this.getCurveMarkPoint(curve.operatingPoint)
            series.push({
              ...defaultOption,
              xAxisIndex,
              yAxisIndex,
              color,
              markPoint
            })
          }
        }
        if (this.designPropertyData) {
          const parabolaSeries = this.getParabolaSeries()
          series.push(...parabolaSeries)
        }
        option.series = series
        this.showCurve()
      } else {
        console.log('y轴无信息')
      }
    },
    /** 转速变化
     * goal:更新series和legend
     */
    speedChange(value) {
      const series = []
      const legendData = {}
      const curves = this.performanceCurveData.curves
      const yAxises = this.option.yAxis
      for (let j = 0; j < curves.length; j++) {
        const curve = curves[j]
        const speed = curve.speed
        if (speed === value || value === 'all') {
          const yAxisIndex = yAxises.findIndex((y) => y.name === `${curve.yName}(${curve.yUnit})`)
          if (yAxisIndex >= 0) {
            const xAxisIndex = yAxises[yAxisIndex] && yAxises[yAxisIndex].gridIndex
            const color = yAxises[yAxisIndex] && yAxises[yAxisIndex].axisLine.lineStyle.color
            const defaultOption = this.getDefaultSeriesOption(curve)
            const markPoint = this.getCurveMarkPoint(curve.operatingPoint)
            series.push({
              ...defaultOption,
              xAxisIndex,
              yAxisIndex,
              color,
              markPoint
            })
            legendData[curve.yName] = true
          }
        }
      }
      if (this.designPropertyData) {
        const parabolaSeries = this.getParabolaSeries() 
        series.push(...parabolaSeries) // 相似抛物线需要一直跟随
      }
      const legend = Object.keys(legendData).map((l) => {
        return { name: l }
      })
      const legendOld = this.option.legend
      this.option.legend = {
        ...legendOld, // 需要记住图例原本的属性
        data: legend,
      }
      this.option.series = series
      this.showCurve(true)
    },
    /** 控制需求点展示
     * goal:通过legend的selected属性控制抛物线是否展示
     */
    designChange(value) {
      this.showDesignPoints = value
      const parabolas = this.parabolas
      if (parabolas && parabolas.length) {
        const selectedNew = {}
        parabolas.forEach((p, index) => {
          const keyName = `parabola${index}`
          selectedNew[keyName] = value
        })
        this.option.legend.selected = {
          ...selectedNew
        }
        
        this.showCurve(true)
      }
    },
    /** 控制运行点展示
     * goal:每条性能曲线是否有markPoint属性
     */
    operatingChange(value) {
      this.showOperatingPoints = value
      if (this.operatingData) {
        const series = this.option.series
        const curves = this.performanceCurveData.curves
        for (let j = 0; j < curves.length; j++) {
          const curve = curves[j]
          const someSeries = series.find((s) => s.name === curve.yName && s.endLabel.formatter === curve.speed)
          if (someSeries) {
            someSeries.markPoint = value ? this.getCurveMarkPoint(curve.operatingPoint) : null
          }
        }
        this.showCurve(true)
      }
    }
  }
}
</script>
<style lang='less' scoped>
.fan-curve{
  margin: 0 auto;
}
.performance-curve-container {
  position: relative;
  padding-top: 10px;
  .select-section{
    padding-left: 12px;
  }
  .selector{
      padding-left: 24px;
      width: 120px;
    }
  .curve-selection-no-speed{
    position: absolute;
    left: 12px;top:16px;
    line-height: 24px;
    &.curve-selection{
      top:48px;
    }
  }
}
</style>
